import "@vm-synthia/sdk-react/fonts.css";
import "@vm-synthia/sdk-react/styles.css";
import { ACL_SESSION_STORAGE, IS_ACL_ENABLED, IS_ROUTE_ENABLED } from "component/utils/Constant";
import React, { memo, useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import { setBeURL, setEnvFrom, setIsHost } from "store/AppGlobalStore";
import { getEnvVariableValue, waitForEnvReady } from "util/CommonUtil";
import { ENV_VAR } from "util/Constant";
import App from "./App";
import i18nInstance from "./i18n";
import * as serviceWorker from "./serviceWorker";
import "./styles/custom-primereact.css";
import "./styles/theme-sdk.css";

//
import "@vm-synthia/sdk-react/prismtheme.css";
import "asset/custom.css";

interface IAppInitializerProps {
  isHost?: boolean;
  remoteName?: string;
  basePath?: string; // Base path from host - if provided, will be used instead of calculating from isHost/remoteName
  beURL?: string;
}

const AppInitializer: React.FC<IAppInitializerProps> = (props: IAppInitializerProps) => {
  const { isHost = false, remoteName = "", basePath = "", beURL = "" } = props;
  const containerId = getEnvVariableValue("VITE_REMOTE_NAME") || "enterprisegpt";

  useEffect(() => {
    // Wait for environment variables to be ready before initializing
    waitForEnvReady().then(() => {
      // to hide console in prod
      if (getEnvVariableValue(ENV_VAR.VITE_SHOW_LOGS) === "false") console.log = () => {};

      // configure withAuth Hoc
      if (getEnvVariableValue(ENV_VAR.VITE_IS_ACL_ENABLED) === IS_ACL_ENABLED.Y) {
        sessionStorage.setItem(ACL_SESSION_STORAGE.IS_ACL_ENABLED, IS_ACL_ENABLED.Y);
      }

      if (getEnvVariableValue(ENV_VAR.VITE_IS_ROUTE_GUARD) === IS_ROUTE_ENABLED.Y) {
        sessionStorage.setItem(ACL_SESSION_STORAGE.IS_ROUTE_GUARD, IS_ROUTE_ENABLED.Y);
      }

      // Service Worker setup
      if (getEnvVariableValue("VITE_ENABLE_PWA_MODE")) {
        // to enable PWA mode uncomment the following
        serviceWorker.register({
          onSuccess: () => {
            console.log("SW >>> SUCCESSFULLY REGISTERED!!!");
          },
          onUpdate: (reg: any) => {
            console.log("SW >>> NEW UPDATE IS AVAILABLE!!!");
          },
        });
      } else {
        // standard mode service workers are off i.e not PWA mode
        serviceWorker.unregister();
      }
    });
  }, []);

  useEffect(() => {
    setIsHost(!!isHost);
    setEnvFrom(remoteName);
    setBeURL(beURL);

    //registerAndLoadHost();
  }, [isHost, remoteName]);

  return (
    <I18nextProvider i18n={i18nInstance}>
      <div id={containerId} className="h-full w-full min-w-0 overflow-hidden">
        <div id={`errorDiv${containerId}`} className="fixed top-0 z-[1000] w-full" />
        <div
          id={`notificationBannerTop${containerId}`}
          className="sticky z-50"
          style={{ top: "0px" }}
        />
        <App isHost={isHost} remoteName={remoteName} basePath={basePath} />
        <div
          id={`notificationBannerBottom${containerId}`}
          className="sticky z-40"
          style={{ bottom: "0px" }}
        />
      </div>
    </I18nextProvider>
  );
};

export default memo(AppInitializer);
